import type { AbsolutePath } from "shelving";
import { Ago, MenuButton, Page } from "shared/react";
import { EntityBackgroundHeader } from "../entity/EntityBackgroundHeader.js";
import { EntityButton } from "../entity/EntityButton.js";
import { EmbedMarkup } from "../misc/EmbedMarkup.js";
import { ReactionSummary } from "../reaction/ReactionSummary.js";
import { useCreatorItem } from "../util/data.js";
import { useItem } from "../util/db.js";
import { NoteMenu } from "./NoteMenu.js";

export function NotePage({ id }: { id: string }): React.ReactElement {
	const { slug, name, content, creator, reactions, updated } = useItem("note", id).data;
	const username = useCreatorItem(creator).value?.username;
	const entity = `note:${id}` as const;
	const path: AbsolutePath = username ? `/${username}/${slug}` : `/note/${id}`;
	return (
		<Page title={name} path={path}>
			<EntityBackgroundHeader entity={creator} mods="pad-3x">
				<h1 className="space-none">{name}</h1>
				<ul className="label status space-none">
					<li>Note</li>
					<li>
						<Ago target={updated} />
					</li>
				</ul>
				<MenuButton menu={<NoteMenu id={id} />} mods="button-quiet pin-top pin-right" />
				<EntityButton entity={creator} mods="pin-bottom pin-left size-small" />
				<ReactionSummary target={entity} count={reactions} mods="pin-bottom pin-right size-small" />
			</EntityBackgroundHeader>
			{content ? (
				<section>
					<EmbedMarkup>{content}</EmbedMarkup>
				</section>
			) : null}
		</Page>
	);
}
